import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WhatsappAlertComponent } from '../whatsapp-alert/whatsapp-alert.component';
import { AddUserComponent } from '../add-user/add-user.component';
import { METWISE_MODULES, MetwiseModuleGroup, SIDEBAR_BUTTONS, SubModule, subModuleRoute } from './side-nav-menu.constants';

@Component({
  selector: 'app-side-nav-menu',
  templateUrl: './side-nav-menu.component.html',
  styleUrls: ['./side-nav-menu.component.scss']
})
export class SideNavMenuComponent implements OnInit {

  @Input() otherOptions: any;
  @Input() routeParams: any;
  @Input() sidebarToggle:any;
  /** fa-bars module menu (replaces the icon bar while open): the host owns the state and closes it on menuClose */
  @Input() menuOpen = false;
  @Output() menuClose = new EventEmitter<void>();
  activeSidebar: string = '';
  sidebarButtons = SIDEBAR_BUTTONS;
  /** drawer groups, with each run of single-sub-module groups gathered into one block (drawn under a divider line) */
  moduleBlocks: { singles: boolean; groups: MetwiseModuleGroup[] }[] = METWISE_MODULES.reduce((blocks, group) => {
    const singles = this.isSingle(group);
    const last = blocks[blocks.length - 1];
    if (singles && last && last.singles) {
      last.groups.push(group);
    } else {
      blocks.push({ singles, groups: [group] });
    }
    return blocks;
  }, []);
  isSplitScreenModule:boolean = false
  constructor(private router: Router, private modalService: NgbModal) { }
  ngOnInit() {
    this.isSplitScreenModule = this.router.url.split('/')[1] === 'splitscreen'    
   }
  onMainSidebarClick(type: string) {
    this.activeSidebar = type;
    if (type === 'heat') {
      this.router.navigate(['/heatwatch/heatindex']);
    } else if (type === 'rainfall') {
      this.router.navigate(['/weatherforecast/rainfall-forecast']);
    } else if (type === 'fog') {
      localStorage.getItem('isFogUserLoggedIn') === 'true' ? this.router.navigate(['/fogwatch/fog']) : this.router.navigate(['/foglogin']);
    } else if (type === 'light') {
      localStorage.getItem('isLightningUserLoggedIn') === 'true' ? this.router.navigate(['/lightning/light']) : this.router.navigate(['/userlogin']);
    } else if (type === 'land-subsidence') {
      this.router.navigate(['/land-subsidence/ls']);
    } else if (type === 'splitscreen') {
      this.router.navigate(['/splitscreen/view']);
    } else if (type === 'metmind') {
      this.router.navigate(['/metmind/landing']);
    } else if (type === 'satellite') {
      this.router.navigate(['/satellite/ctt']);
    } else if (type === 'dryspell') {
      this.router.navigate(['/dryspelllogin']);
    } else if (type === 'forecast') {
      this.router.navigate(['/forecast/wind-speed-forecast']);
    } else if (type === 'urban-heat-island') {
      localStorage.getItem('isUrbanHeatIslandUserLoggedIn') === 'true' ? this.router.navigate(['/urban-heat-island/uhi']) : this.router.navigate(['/urbanHeatIslandLogin']);
    } else if (type === 'metwiseAlerts') {
      localStorage.getItem('isMetwiseAlertsUserLoggedIn') === 'true' ? this.router.navigate(['/metwiseAlerts/feed']) : this.router.navigate(['/metwiseAlertsLogin']);
    } else if (type === 'drought') {
      localStorage.getItem('isDroughtUserLoggedIn') === 'true' ? this.router.navigate(['/drought/dm']) : this.router.navigate(['/droughtlogin']);
    } else if (type === 'crop-yield') {
      localStorage.getItem('isCropYieldUserLoggedIn') === 'true' ? this.router.navigate(['/crop-yield/cy']) : this.router.navigate(['/cropyieldlogin']);
    } else if (type === 'sdmp') {
      this.router.navigate(['/monitoring-plan']);  // SdmpAuthGuard sends signed-out users to /monitoring-plan/signin
    }
  }

  /** drawer group of the current page: its first URL segment, or one of its tiles */
  isActiveGroup(group: MetwiseModuleGroup): boolean {
    return group.urlSegments.includes(this.router.url.split('?')[0].split('/')[1])
      || group.items.some(item => this.isActiveSubModule(item));
  }

  /** drawer tile of the current page */
  isActiveSubModule(item: SubModule): boolean {
    const path = this.router.url.split('?')[0];
    return path === item.route[0] || path.startsWith(item.route[0] + '/');
  }

  openSubModule(item: SubModule) {
    this.router.navigate(subModuleRoute(item));
    this.closeMenu();
  }

  @HostListener('document:keydown.escape')
  closeMenu() {
    if (this.menuOpen) { this.menuClose.emit(); }
  }

  /** one sub-module and no heading: a single cell named after its module */
  isSingle(group: MetwiseModuleGroup): boolean {
    return group.items.length === 1 && !group.headed;
  }

  trackById(_: number, group: MetwiseModuleGroup) { return group.id; }

  trackByType(_: number, item: SubModule) { return item.type; }

  whatsappAlert() {
    this.modalService.open(WhatsappAlertComponent);
  }

  adminPanel() {
    this.modalService.open(AddUserComponent);
  }

  logout() {
    if (this.router.url.startsWith('/lightning')) {
      sessionStorage.setItem('logoutFromLightning', 'true');
      localStorage.removeItem('isLightningUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/userlogin']);
    } else if (this.router.url.startsWith('/nowcastweather')) {
      sessionStorage.setItem('logoutFromNowcast', 'true');
      localStorage.removeItem('isNowcastUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/nowcastlogin']);
    } else if (this.router.url.startsWith('/dryspell')) {
      sessionStorage.setItem('logoutFromDrySpell', 'true');
      localStorage.removeItem('isDrySpellUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/dryspelllogin']);
    } else if (this.router.url.startsWith('/fogwatch')) {
      sessionStorage.setItem('logoutFromFog', 'true');
      localStorage.removeItem('isFogUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/foglogin']);
    } else if (this.router.url.startsWith('/metwiseAlerts')) {
      sessionStorage.setItem('logoutFromMetwiseAlerts', 'true');
      localStorage.removeItem('isMetwiseAlertsUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/metwiseAlertsLogin']);
    } else if (this.router.url.startsWith('/urban-heat-island')) {
      sessionStorage.setItem('logoutFromUrbanHeatIsland', 'true');
      localStorage.removeItem('isUrbanHeatIslandUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/urbanHeatIslandLogin']);
    } else if (this.router.url.startsWith('/drought')) {
      sessionStorage.setItem('logoutFromDrought', 'true');
      localStorage.removeItem('isDroughtUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/droughtlogin']);
    } else if (this.router.url.startsWith('/crop-yield')) {
      sessionStorage.setItem('logoutFromCropYield', 'true');
      localStorage.removeItem('isCropYieldUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/cropyieldlogin']);
    } else if (this.router.url.startsWith('/splitscreen')) {
      sessionStorage.setItem('logoutFromSplitScreen', 'true');
      localStorage.removeItem('isSplitScreenUserLoggedIn');
      localStorage.removeItem('metaInfo');
      localStorage.removeItem('allowedToCreateUser');
      this.router.navigate(['/splitscreenlogin']);
    } else {
      localStorage.clear();
      this.router.navigate(['/userlogin']);
    }
  }
}